module.exports = __webpack_public_path__ + "static/img/404_imgbg.165fde9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/404_imgbg.png
// module id = zAjA
// module chunks = 88